import { Component } from 'react'
import { fetchNotifications } from 'store/actions'
import { step, minDelay, maxDelay, initialDelay } from 'config/notifications.config'
import { withRouter } from 'react-router'

import { connect } from 'react-redux'

class NotificationPoller extends Component {
  timer = null;
  delay = initialDelay;
  min = minDelay;
  max = maxDelay;
  step = step;

  componentDidMount() {
    this.fetchNotifications()

    this.unlisten = this.props.history.listen(() => {
      this.delay > this.min && this.fetchNotifications(this.min)
    })
  }

  componentWillUnmount() {
    this.unlisten()
    clearTimeout(this.timer)
    this.timer = null
  }

  fetchNotifications(delay) {
    const { profile, items, fetchNotifications, pingNotifications } = this.props
    if (!sessionStorage.disableNotifications && !profile.error && pingNotifications) {
      clearTimeout(this.timer)
      if (delay) {
        this.delay = delay
      } else {
        fetchNotifications()

        // If no notifications in the last maxDelay time - increase poller delay by one step
        if (!items.find(n => n.timestamp < +new Date() + this.max)) {
          this.delay = Math.min(this.delay + this.step, this.max)
        }
      }
      this.timer = setTimeout(() => this.fetchNotifications(), this.delay)
    }
  }

  render = () => null;
}

export default withRouter(
  connect(s => ({ profile: s.myProfile, items: s.notifications.items, pingNotifications: !s.notifications.error }), {
    fetchNotifications,
  })(NotificationPoller)
)
